import React, { useEffect, useState } from "react";
import GoogleMapReact from "google-map-react";
import { connect, useDispatch } from "react-redux";
import { Chip } from "@material-ui/core";
import Popper from "@material-ui/core/Popper";
import Fade from "@material-ui/core/Fade";
import Paper from "@material-ui/core/Paper";
import "./index.scss";

import { GOOGLE_MAPS_KEY } from "../../../Common/commonMethods";
import SearchLocationInput from "./GooglePlacesAutocomplete";

const AnyReactComponent = ({
  text,
  location,
  match,
  history,
  uuid,
  resetClassValue,
}) => {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const [placement, setPlacement] = React.useState();

  const handleClick = (newPlacement) => (event) => {
    setAnchorEl(event.currentTarget);
    setOpen((prev) => placement !== newPlacement || !prev);
    setPlacement(newPlacement);
  };

  return (
    <div onClick={handleClick("bottom")} title={text}>
      <Popper open={open} anchorEl={anchorEl} placement={placement} transition>
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <Paper>
              <div
                className="d-flex align-items-center ml-3 mb-3"
                style={{ padding: "20px" }}
              >
                {location && location.venueImage && (
                  <div className="symbol symbol-150 mr-3">
                    <img
                      className="venue_logo_section"
                      src={location && location.venueImage}
                    />
                  </div>
                )}
                <div class="symbol symbol-150 mr-3">
                  <h3>{location && location.name}</h3>
                  <p>
                    {location &&
                      location.address +
                        ", " +
                        location.suburb +
                        ", " +
                        location.postcode +
                        ", " +
                        location.state}
                  </p>
                  <button
                    className="btn btn-primary"
                    onClick={() => {
                      // history.push(
                      //   `/${uuid}/${location._id}/weekly/${match.params.business}`
                      // );
                      dispatch({
                        type: "classes/GET_CLASSES_BY_LOCATION",
                        payload: {
                          locationId: location._id,
                          uuid: match.params.uuid,
                          type: "weekly",
                          business: match.params.business,
                        },
                      });
                      resetClassValue && resetClassValue("classId", []);
                      resetClassValue &&
                        resetClassValue("location", { _id: location?._id });
                    }}
                  >
                    Select
                  </button>
                </div>
              </div>
            </Paper>
          </Fade>
        )}
      </Popper>
      <img src="/media/svg/icons/Communication/Thumbtack.svg" />
      <div>
        <Chip label={text} clickable color="primary" />
      </div>
    </div>
  );
};

const findDefaultLocation = (locations, selectedLocation) => {
  const location =
    selectedLocation && selectedLocation.lat
      ? {
          latitude: parseFloat(selectedLocation.lat),
          longitude: parseFloat(selectedLocation.long),
        }
      : //   : locations?.length > 0
        //   ? locations?.filter(
        //       (location) => location.latitude && location.longitude
        //     )[0]
        {
          longitude: 152.9776332,
          latitude: -27.5038482,
        };

  return location;
};

const WeeklyEnrolmentPage = ({
  dispatch,
  match,
  locations,
  history,
  searched,
  zoom,
  selectedLocation,
  resetClassValue,
}) => {
  // useEffect(() => {
  //   dispatch({
  //     type: "locations/GET_LIST_BY_UUID",
  //     payload: {
  //       uuid: match.params.uuid,
  //       tag: match.params.tag,
  //       business: match.params.business,
  //     },
  //   });
  // }, []);

  return (
    <div className="row">
      <div className="col-md-12 col-sm-12">
        <div style={{ padding: 10 }}>
          <SearchLocationInput dispatch={dispatch} match={match} />
        </div>
        <br />
        <div style={{ height: "400px", width: "100%" }}>
          <GoogleMapReact
            bootstrapURLKeys={{
              key: GOOGLE_MAPS_KEY,
            }}
            center={
              findDefaultLocation(searched, selectedLocation) && {
                lat: parseFloat(
                  findDefaultLocation(searched, selectedLocation).latitude
                ),
                lng: parseFloat(
                  findDefaultLocation(searched, selectedLocation).longitude
                ),
              }
            }
            zoom={zoom}
          >
            {console.log(
              searched,
              match.params.business,
              searched?.filter((location) =>
                location?.classes?.some((cls) =>
                  cls?.service && match.params.business === "ginger"
                    ? cls?.service?.service === "Weekly Fun Soccer"
                    : match.params.business === "quest"
                    ? cls?.service?.service === "Academy Football Coaching"
                    : false
                )
              )
            )}
            {Array.isArray(searched) &&
              searched
                ?.filter((location) =>
                  location?.classes?.some((cls) =>
                    cls?.service && match.params.business === "ginger"
                      ? cls?.service?.service === "Weekly Fun Soccer"
                      : match.params.business === "quest"
                      ? cls?.service?.service === "Academy Football Coaching"
                      : false
                  )
                )
                .map((location) => (
                  <AnyReactComponent
                    key={location._id}
                    lat={location.latitude && parseFloat(location.latitude)}
                    lng={location.longitude && parseFloat(location.longitude)}
                    text={location.name}
                    location={location}
                    history={history}
                    uuid={match.params.uuid}
                    match={match}
                    resetClassValue={resetClassValue}
                  />
                ))}
          </GoogleMapReact>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    show: state.enrolments.show,
    // locations: state.locations.selectedLocations,
    searched: state.locations.searched,
    setting: state.settings.publicSetting,
    classesByLocation: state.classes.classesByLocation,
    students: state.students.studentsByParents,
    zoom: state.locations.zoom,
    selectedLocation: state.locations.selectedInMap,
  };
};

export default connect(mapStateToProps)(WeeklyEnrolmentPage);
